import { render, staticRenderFns } from "./SupplierOrderInfoCardInfo.vue?vue&type=template&id=dc7c9a52&scoped=true&"
import script from "./SupplierOrderInfoCardInfo.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderInfoCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrderInfoCardInfo.vue?vue&type=style&index=0&id=dc7c9a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7c9a52",
  null
  
)

export default component.exports